const paidRateDisclaimer = "Note: May result in overpaying employees when not used with Greater of Comm. and Guaranteed formula.";

export const overtimeTypes = [{
    Name: "No Premiums",
    Value: "NoPremiums",
    Description: "State overtime laws are used, and no premiums are paid.",
    Formula: "OT Premium Rate = 0"
}, {
    Name: "Comm. Rate Premiums",
    Value: "ProportionalCommissionPremiums",
    Description: "Premiums are paid in proportion to commission earned over hours worked, according to state law.",
    Formula: "OT Premium Rate = Commission / Total Hours / 2"
}, {
    Name: "Wage Plus Paid Comm. Rate Premiums",
    Value: "WagePlusPaidCommissionPremiums",
    Description: "Premiums are paid in proportion to commission earned plus guaranteed wage, according to state law. "
        + paidRateDisclaimer,
    Formula: "OT Premium Rate = (Reg Rate * Total Hours + Paid Commission) / Total Hours / 2 - Reg Rate / 2"
}, {
    Name: "Comm. Rate Overtime",
    Value: "CommissionRate",
    Description: "Commission rate is used instead of state overtime rate when commissions exceed guaranteed, regardless of state law. No premium is added.",
    Formula: "OT Rate = { commission > guaranteed: Commission / Total Hours  | otherwise: Reg Rate * 1.5 }",
}, {
    Name: "Wage Plus Comm. Rate Overtime",
    Value: "WagePlusCommissionRate",
    Description: "Paid commission rate is added to state overtime rate, regardless of state law. No premium is added. "
        + paidRateDisclaimer,
    Formula: "OT Rate = { commission > guaranteed: (Total Hours * Reg Rate + Paid Commission) / Total Hours * 1.5 | otherwise: Reg Rate * 1.5 }",
}, {
    Name: "Reg Rate Plus Comm. Rate",
    Value: "RegularPlusCommissionRate",
    Description: "Regular rate is added to commission rate, regardless of state law. No premium is added.",
    Formula: "OT Rate = { commission > guaranteed: Reg Rate + Commission / 2 | otherwise: Reg Rate * 1.5 }"
}, {
    Name: "Overtime Plus Paid Comm. Rate",
    Value: "OvertimePlusPaidCommissionRate",
    Description: "Overtime rate is added to commission rate, regardless of state law. No premium is added. "
        + paidRateDisclaimer,
    Formula: "OT Rate = Reg Rate * 1.5 + Paid Commission / Total Hours / 2"
}];
